import { useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { type BoxProps } from '@hivebrite/design-system/Box';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';
import { FakeLink } from '@hivebrite/design-system/Link';

import { type EventRegistrationHelp } from 'hb-react/shared/apps/Events/types';
import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import { HtmlContent } from 'hb-react/shared/components/HtmlContent';

// Used in FO and in BO for the preview
export const RegistrationHelpContent = ({ content }: { content: string }) => (
  <HtmlContent
    content={content}
    dataTestId="registration-help-content"
    stylesConfig="web"
  />
);

export const RegistrationHelp = ({
  enabled,
  headline,
  content,
  ...otherProps
}: BoxProps & EventRegistrationHelp) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!enabled || (!headline && !content)) {
    return null;
  }

  return (
    <>
      <Box
        {...otherProps}
        onClick={() => setIsOpen(true)}
        style={{ cursor: 'pointer' }}
      >
        <FontAwesomeIcon
          iconName="circle-info"
          iconType={CATEGORIES.SOLID}
          height="18px"
          color="primary"
        />
        <Box ml={2}>
          <FakeLink font="h4-regular">{headline}</FakeLink>
        </Box>
      </Box>
      {isOpen && (
        <ModalWithTemplate
          onCloseModal={() => setIsOpen(false)}
          screenReadersCloseButtonText={s__(
            'Accessibility|Close event registration help window',
          )}
          header=" " // Forces Header to be displayed so the content is positioned properly
        >
          <RegistrationHelpContent content={content} />
        </ModalWithTemplate>
      )}
    </>
  );
};
